import { Outlet, useOutletContext } from 'react-router-dom';
import { useDelayCall, useStickySafeNavigate } from '@equifinance/shared';
import { useCanAccessBrokerDetails } from '../components/BrokerDetails/hooks/useCanAccessBrokerDetails';
import { RoutingContextType } from './types';

export function BrokerDetailsRoutes() {
  const outletValue: RoutingContextType = useOutletContext();

  const contextValue: RoutingContextType = {
    ...outletValue,
  };

  const navigate = useStickySafeNavigate();
  const allowedAccess = useCanAccessBrokerDetails();

  useDelayCall(() => {
    if (!allowedAccess) {
      navigate('/403');
    }
  }, [allowedAccess], true);

  return (
    <>
      {allowedAccess && <Outlet context={contextValue} />}
    </>
  );
}
